import React from 'react';

const Documentation = () => {
  return (
    <div className="page">
      <h1>Documentation</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default Documentation; 